import React from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import Select from "react-select";

import { Button } from "reactstrap";
import moment from "moment";
import Loading from "../../../pages/loader/loader";
const TransactionDetailsPopup = (props) => {
  console.log(props.transactionDetails);
  console.log(props);
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      className="rakTransactionModal"
      centered
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ marginBottom: 25 }}>
          <h1 style={{ paddingBottom: "25px" }}>Transactions Details</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: 10 }}>
          <Modal.Body>
            <Container className="mt--6" fluid style={{ paddingTop: "15px" }}>
              <Row className="card-wrapper" style={{ display: "flex" }}>
                <Col lg="6">
                  <h2 className="headerpadding">Receiver</h2>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Name
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {" "}
                      {props.transactionDetails &&
                        props.transactionDetails.beneficiaryDetails &&
                        props.transactionDetails.beneficiaryDetails
                          .firstName}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.beneficiaryDetails &&
                        props.transactionDetails.beneficiaryDetails
                          .middleName}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.beneficiaryDetails &&
                        props.transactionDetails.beneficiaryDetails.lastName}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Country
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.beneficiaryDetails &&
                        props.transactionDetails.beneficiaryDetails.countryName}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Type
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.transferMethod}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Bank Name
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.bankDetails &&
                        props.transactionDetails.bankDetails.bankName}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Account Number
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.bankDetails &&
                        props.transactionDetails.bankDetails.accountNumber}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      IFSC/IBAN
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.bankDetails &&
                        props.transactionDetails.bankDetails.bankCode}
                    </Col>
                  </Row>
                  <h2 className="headerpadding">Sender</h2>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Name
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.sender &&
                        props.transactionDetails.sender.name}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Country
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.sender &&
                        props.transactionDetails.sender.country}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Mobile Number
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {/* {props.allUsersObject.phoneNumber} */}
                      {props.transactionDetails &&
                        props.transactionDetails.sender &&
                        props.transactionDetails.sender.mobileNumber}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Reversal Remark
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {/* {props.allUsersObject.phoneNumber} */}
                      {props.transactionDetails &&
                        props.transactionDetails.remarks}
                    </Col>
                  </Row>
                </Col>
                <Col lg="6">
                  <h2 className="headerpadding">Transaction</h2>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Date
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {moment(
                        props.transactionDetails &&
                          props.transactionDetails.dateSent
                      ).format("DD-MM-YY")}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Sent({" "}
                      {props.transactionDetails &&
                        props.transactionDetails.sendAmount &&
                        props.transactionDetails.sendAmount.currency}
                      )
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.sendAmount &&
                        props.transactionDetails.sendAmount.amount}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.sendAmount &&
                        props.transactionDetails.sendAmount.currency}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      FxRate
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.conversionRate}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Transaction Fees{" "}
                      {/* {props.transactionDetails &&
                      props.transactionDetails.fee.currency}
                    ) */}
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.fee &&
                        props.transactionDetails.fee.amount}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.fee &&
                        props.transactionDetails.fee.currency}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Waived({" "}
                      {props.transactionDetails &&
                        props.transactionDetails.waivedCharge &&
                        props.transactionDetails.waivedCharge.currency}
                      )
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.waivedCharge &&
                        props.transactionDetails.waivedCharge.amount}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.waivedCharge &&
                        props.transactionDetails.waivedCharge.currency}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Debited({" "}
                      {props.transactionDetails &&
                        props.transactionDetails.debitCurrency &&
                        props.transactionDetails.debitCurrency.currency}
                      )
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {/* {props.transactionDetails &&
                      props.transactionDetails.debitCurrency &&
                      props.transactionDetails.debitCurrency.amount}{" "} */}
                      {parseFloat(
                        props.transactionDetails &&
                          props.transactionDetails.sendAmount &&
                          props.transactionDetails.sendAmount.amount
                      ) +
                        parseFloat(
                          props.transactionDetails &&
                            props.transactionDetails.fee &&
                            props.transactionDetails.fee.amount
                        )}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.debitCurrency &&
                        props.transactionDetails.debitCurrency.currency}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Received({" "}
                      {props.transactionDetails &&
                        props.transactionDetails.receiveAmount &&
                        props.transactionDetails.receiveAmount.currency}
                      )
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.receiveAmount &&
                        props.transactionDetails.receiveAmount.amount}{" "}
                      {props.transactionDetails &&
                        props.transactionDetails.receiveAmount &&
                        props.transactionDetails.receiveAmount.currency}
                      {/* {props.transactionDetails &&
                      props.transactionDetails.receiveAmount.currency}
                     ({" "}
                    {props.transactionDetails &&
                      props.transactionDetails.receiveAmount.amount}
                    )  */}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Purpose
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.moneyTransferPurpose}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      C3 Ref
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.c3Ref}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      RAK Ref
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {/* {props.transactionDetails &&
                      props.transactionDetails.rakRef} */}
                      {props.transactionDetails &&
                      props.transactionDetails.rakRef ===
                        "00000000-0000-0000-0000-000000000000"
                        ? "N/A"
                        : props.transactionDetails &&
                          props.transactionDetails.rakRef}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Status
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      <div>
                        {props.transactionDetails &&
                          props.transactionDetails.status}
                      </div>
                      <div>
                        <Button
                          color="primary"
                          onClick={props.updateStatusClicked}
                          disabled={props.updateloading === true ? true : false}
                        >
                          {props.updateloading ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100px",
                              }}
                            >
                              <Loading
                                color="white"
                                width="20px"
                                height="20px"
                              />
                            </div>
                          ) : (
                            "Update status"
                          )}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Status Reason
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.remarks}
                    </Col>
                  </Row>
                  <Row
                    className="modal-body-content"
                    style={{ padding: "5px 0px" }}
                  >
                    <Col lg="5" className="label-bank-details">
                      Referrer Code
                    </Col>
                    <Col lg="1">:</Col>
                    <Col lg="6">
                      {props.transactionDetails &&
                        props.transactionDetails.referralCode}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        </div>
      </Modal.Body>
    </Modal>
    // <Modal
    //   {...props}
    //   size="lg"
    //   aria-labelledby="example-custom-modal-styling-title"
    //   centered
    //   animation={true}
    //   dialogClassName="modal-90w"
    // >
    //   <Modal.Header closeButton>
    //     <Modal.Title
    //       id="example-custom-modal-styling-title"
    //       style={{ textAlign: 'left' }}
    //     >
    //       Transaction Details
    //     </Modal.Title>
    //   </Modal.Header>
    //   <Modal.Body>
    //     <Container>
    //       <Row style={{ padding: '10px 0px' }}>
    //         <Col
    //           xs={12}
    //           md={5}
    //           style={{ border: '1px solid grey', margin: 10 }}
    //         >
    //           <div
    //             style={{
    //               color: 'black',
    //               display: 'flex',
    //               flexDirection: 'column',
    //               paddingBottom: 30,
    //             }}
    //           >
    //             <div style={{ paddingTop: 30 }}>
    //               <p style={{ fontWeight: 800, lineHeight: 0 }}>Receiver</p>
    //             </div>
    //             <div
    //               style={{
    //                 width: '100%',
    //                 borderBottom: '4px solid grey',
    //                 marginBottom: 5,
    //               }}
    //             />
    //             <div>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Name:{' '}
    //               </span>{' '}

    //             </div>
    //             <div>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Country:{' '}
    //               </span>{' '}

    //             </div>
    //             <div>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Type:
    //               </span>{' '}

    //             </div>
    //             <div>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Bank Name:
    //               </span>{' '}

    //             </div>
    //             <div>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Name:
    //               </span>{' '}
    //               Crossain Bugette
    //             </div>
    //             <div>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Account Number:
    //               </span>{' '}
    //               46546454564
    //             </div>
    //             <div>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 {' '}
    //                 IFSC/IBAN:{' '}
    //               </span>{' '}
    //               HDAIF454564
    //             </div>
    //           </div>
    //           <div
    //             style={{
    //               color: 'black',
    //               display: 'flex',
    //               flexDirection: 'column',
    //             }}
    //           >
    //             <div>
    //               <p style={{ fontWeight: 800, lineHeight: 0 }}>Sender</p>
    //             </div>
    //             <div
    //               style={{
    //                 width: '100%',
    //                 borderBottom: '4px solid grey',
    //                 marginBottom: 5,
    //               }}
    //             />
    //             <div>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Name:{' '}
    //               </span>{' '}
    //               Amit Malyas Jesa
    //             </div>
    //             <div>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Country:{' '}
    //               </span>{' '}
    //               India
    //             </div>
    //             <div>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Mobile Number:{' '}
    //               </span>{' '}
    //               9780546589
    //             </div>
    //           </div>
    //         </Col>
    //         <Col
    //           xs={12}
    //           md={6}
    //           style={{ border: '1px solid grey', margin: 10 }}
    //         >
    //           <div
    //             style={{
    //               color: 'black',
    //               display: 'flex',
    //               flexDirection: 'column',
    //             }}
    //           >
    //             <div style={{ paddingTop: 30 }}>
    //               <p style={{ fontWeight: 800, lineHeight: 0 }}>Transaction</p>
    //             </div>
    //             <div
    //               style={{
    //                 width: '100%',
    //                 borderBottom: '4px solid grey',
    //                 marginBottom: 5,
    //               }}
    //             />
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Date:{' '}
    //               </span>{' '}
    //               20-10-20 12:12{' '}
    //             </div>
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Sent(AED):{' '}
    //               </span>{' '}
    //               25.00
    //             </div>
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 FxRate:
    //               </span>{' '}
    //               0.051
    //             </div>
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Transaction Fee(AED):
    //               </span>
    //               5.25
    //             </div>
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Waived:
    //               </span>{' '}
    //               0.00
    //             </div>
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Received:
    //               </span>{' '}
    //               482.11 INR
    //             </div>
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 {' '}
    //                 Purpose:{' '}
    //               </span>{' '}
    //               Family Maintanence and Savings
    //             </div>
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 RAK Ref:
    //               </span>
    //               1650978545
    //             </div>
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Counted towards Loyalty:
    //               </span>
    //               Yes/No
    //             </div>
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Status:
    //               </span>
    //               Pending{' '}
    //               <button
    //                 style={{
    //                   background: '#6558f5',
    //                   border: 'none',
    //                   padding: '10px 10px',
    //                   color: 'white',
    //                   borderRadius: 5,
    //                 }}
    //               >
    //                 Update status
    //               </button>
    //             </div>
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Status Reason:
    //               </span>
    //               Waiting for corresponding bank authorization
    //             </div>
    //             <div style={{ padding: '5px 0px' }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Refferer Code:
    //               </span>
    //               AZR123
    //             </div>
    //           </div>
    //         </Col>
    //       </Row>
    //     </Container>
    //   </Modal.Body>
    // </Modal>
  );
};

export default TransactionDetailsPopup;
